import { render, staticRenderFns } from "./myFoodOrderList.vue?vue&type=template&id=0e3f07ba&scoped=true"
import script from "./myFoodOrderList.vue?vue&type=script&lang=js"
export * from "./myFoodOrderList.vue?vue&type=script&lang=js"
import style0 from "./myFoodOrderList.vue?vue&type=style&index=0&id=0e3f07ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f07ba",
  null
  
)

export default component.exports